import React from 'react'
import { isEmpty, trim, compose, defaultTo, prop, pathOr, map } from 'ramda'
import { useForm, useFetch } from '../../../../hooks'
import Button from '../../../../components/inputs/Button'
import Buttons from '../../../../modules/Buttons'
import { FormHeader, FormBody, FormBodyText, Icon, Form } from '../../../../modules/Form/styled'
import FromInput from '../../../../components/inputs/FromInput'
import FromSelect from '../../../../components/inputs/FromSelect'
import { toast } from 'react-toastify'

const FormAddZone = ({ translation, onClickCancel, refetchZones }) => {
    const { response, fetching, doFetch } = useFetch({
        url: '/rpc/add_zone',
        method: 'POST'
    })

    const addZone = async values => {
        const { zone_name, sensor } = values;
        const res = await doFetch({
            data: {
                zone_name,
                sensor: sensor ? parseInt(sensor) : null
            }
        })
        if (res === 0) {
            const error = pathOr(null, ['error'], translation);
            error && toast.error(error);
        }
    }

    const validate = values => {
        const isEmptyZoneName = compose(isEmpty, trim, defaultTo(''), prop('zone_name'))
        if (isEmptyZoneName(values)) {
            return {
                zone_name: pathOr('', ['hint'], translation)
            }
        }
        return {}
    }

    const { values, errors, handleChange, handleSubmit } = useForm({
        callback: addZone,
        validate: validate
    })

    const handleClickCancel = () => {
        onClickCancel()
    }

    const handleClickClose = () => {
        refetchZones && refetchZones()
        onClickCancel()
    }

    return (
        <Form onSubmit={handleSubmit} noValidate autoComplete="off">
            <FormHeader>
                {pathOr("", ['title'], translation)}
            </FormHeader>
            <FormBody>
                {
                    (isEmpty(response.data) || response.data === 0) ?
                        <>
                            <FromInput
                                type='text'
                                placeholder={pathOr("", ["placeholder"], translation)}
                                name='zone_name'
                                onChange={handleChange}
                                value={values.zone_name}
                                error={errors.zone_name}
                                fullWidth
                                margin="0 0 10px 0"
                            />
                            <FromSelect
                                name='sensor'
                                placeholder={pathOr("", ["placeholder2"], translation)}
                                onChange={handleChange}
                                value={values.sensor}
                                error={errors.sensor}
                                options={compose(
                                    map(option => ({ value: option, label: option })),
                                    pathOr("", ["data"])
                                )(translation)}
                            />
                            <Buttons>
                                <Button
                                    type='submit'
                                    fullWidth
                                    green
                                    disabled={fetching}
                                >
                                    {pathOr("", ["buttons", "save"], translation)}
                                </Button>
                                <Button
                                    type='button'
                                    fullWidth
                                    onClick={handleClickCancel}
                                >
                                    {pathOr("", ["buttons", "cancel"], translation)}
                                </Button>
                            </Buttons>
                        </>
                        :
                        <>
                            <FormBodyText>
                                <Icon width='80' height='80' viewBox="0 0 24 24">
                                    <polyline points="20 6 9 17 4 12" />
                                </Icon>
                            </FormBodyText>
                            <Button
                                type='button'
                                fullWidth
                                onClick={handleClickClose}
                            >
                                {pathOr("", ["buttons", "close"], translation)}
                            </Button>
                        </>
                }
            </FormBody>
        </Form>
    )
}

export default FormAddZone
